import { formatLiveSession } from "_common/utils/broadcast";

export const formatLiveSessions = ( list = [] ) => {
	return list.map ( item => formatLiveSession ( item ) );
};